import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { useRouter, useSearchParams } from 'next/navigation';

import { PlayerVideosTournaments } from '@/types/players.types';

interface VideosTournamentsDropdownProps {
  tournaments: PlayerVideosTournaments[];
}

const VideosTournamentsDropdown = ({ tournaments }: VideosTournamentsDropdownProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const currentTournament = searchParams?.get('tournament');

  const isAllTournaments = currentTournament === 'all' || currentTournament === null;

  const currentTournamentLabel = isAllTournaments
    ? 'All tournaments'
    : tournaments.find((t) => t.tournamentUuid === currentTournament)?.tournamentTitle;

  const handleTournamentSelect = (tournamentUuid: string) => {
    router.replace(`?tournament=${tournamentUuid}&page=1`);
  };

  return (
    <Menu showArrow={false} offset={5} placement='bottom-start'>
      <Menu.Trigger asChild>
        <Button
          variant='secondary'
          className={clsx(
            '!border-1 flex !h-[44px] !w-[320px] justify-between !rounded-lg !border-gray-300 !bg-white !font-normal !text-gray-900 transition-all'
          )}
          suffixIcon={<FontAwesomeIcon icon={faAngleDown} />}
          data-testid='player-tournament-videos-button'
        >
          <span className='truncate'>{currentTournamentLabel}</span>
        </Button>
      </Menu.Trigger>
      <Menu.List className='h-[240px] w-fit min-w-[200px] animate-fade-in overflow-y-scroll'>
        <Menu.Item
          isActive={isAllTournaments}
          className={clsx(
            'mb-1 flex h-8 cursor-pointer items-center rounded-md px-3 text-sm font-normal hover:bg-gray-100',
            isAllTournaments ? '!bg-experiment text-white' : 'text-gray-900'
          )}
          onClick={() => handleTournamentSelect('all')}
          data-testid='player-tournament-videos-all'
        >
          All tournaments
        </Menu.Item>
        {tournaments.map((tournament) => (
          <Menu.Item
            key={`player-tournament-videos-${tournament.tournamentUuid}`}
            isActive={currentTournament === tournament.tournamentUuid}
            className={clsx(
              'mb-1 flex h-8 cursor-pointer items-center rounded-md px-3 text-sm font-normal hover:bg-gray-100',
              currentTournament === tournament.tournamentUuid
                ? '!bg-experiment text-white'
                : 'text-gray-900'
            )}
            onClick={() => handleTournamentSelect(tournament.tournamentUuid)}
            data-testid={`player-tournament-videos-${tournament.tournamentUuid}`}
          >
            {tournament.tournamentTitle}
          </Menu.Item>
        ))}
      </Menu.List>
    </Menu>
  );
};

export default VideosTournamentsDropdown;
